import { Preload } from "./Preload";

export default Preload;
